export const matchTypeValues = ['include', 'exclude', 'regex'] as const

export type MatchType = (typeof matchTypeValues)[number]
